import { isEmpty } from "@utils/var.check";

const SUBJECT_COLOR_MAP = {
  ADMT: "#F17E7E",
  APPLMTL: "#24BDC7",
  ART: "#F17E7E",
  "ART (NA)": "#F17E7E",
  "ART(AEP)": "#F17E7E",
  ASC3DATP01: "#AF75D2",
  ASIEDSP01: "#AF75D2",
  ASNPFE01: "#AF75D2",
  ASNPMSCL03: "#24BDC7",
  ASNPMSEL02: "#2B63D9",
  ASNPMSEL06: "#2B63D9",
  BENGALI: "#24BDC7",
  BI: "#24BDC7",
  "BIO SC": "#73C235",
  "BIO(SPA)": "#73C235",
  BK: "#707880",
  BL: "#24BDC7",
  BSPGRM: "#24BDC7",
  BTL: "#24BDC7",
  BURMESE: "#707880",
  "C(SP)": "#24BDC7",
  CCA: "#707880",
  CCE: "#B44931",
  "CCM(CL)": "#24BDC7",
  "CCM(ML)": "#24BDC7",
  "CH(SS,GE)": "#E4A607",
  "CH(SS,HE)": "#E4A607",
  "CH(SS,LC)": "#E4A607",
  "CH(SS,LE)": "#E4A607",
  "CH(SS,LM)": "#E4A607",
  "CH(SS,LT)": "#E4A607",
  "CHEM(SPA)": "#73C235",
  CIVICS: "#B44931",
  CL: "#24BDC7",
  "CL(SP)": "#24BDC7",
  CLB: "#24BDC7",
  "COMP STUD": "#AF75D2",
  COMPNET: "#AF75D2",
  "D&T": "#AF75D2",
  DIGLIT: "#707880",
  EL: "#2B63D9",
  "EL1(SYLA)": "#2B63D9",
  ELECTECH: "#AF75D2",
  FBL: "#24BDC7",
  FCE: "#AF75D2",
  FCL: "#24BDC7",
  FEL: "#2B63D9",
  FGL: "#24BDC7",
  FHL: "#24BDC7",
  FMATHS: "#F3812F",
  FML: "#24BDC7",
  FNMATHS: "#F3812F",
  FPL: "#24BDC7",
  FRENCH: "#707880",
  FSC: "#73C235",
  FSCI: "#73C235",
  "FSCI NON-E": "#73C235",
  FTGP: "#B44931",
  FTL: "#24BDC7",
  FUL: "#24BDC7",
  G1ART: "#F17E7E",
  "ART (NT)": "",
  G1CL: "#24BDC7",
  G1CPA: "#AF75D2",
  "G1D&T": "",
  G1EBS: "#AF75D2",
  G1EL: "#2B63D9",
  G1ELECTECH: "#AF75D2",
  G1FS: "#AF75D2",
  "FS (N)": "",
  G1MATHS: "#F3812F",
  G1ML: "#24BDC7",
  "MUSIC (NT)": "",
  G1MUSIC: "#F17E7E",
  G1RETAILOP: "#AF75D2",
  G1ROBOTICS: "#AF75D2",
  G1SCI: "#73C235",
  G1SS: "#E4A607",
  G1TL: "#24BDC7",
  G2AMATHS: "#F3812F",
  "A MATHS NA": "",
  G2ART: "#F17E7E",
  G2BL: "#24BDC7",
  "CL N(A)": "#24BDC7",
  G2CL: "",
  "G2D&T": "#AF75D2",
  G2EL: "#2B63D9",
  G2FCE: "#AF75D2",
  G2GEOG: "#E4A607",
  G2GL: "#24BDC7",
  G2HIST: "#E4A607",
  G2HL: "#24BDC7",
  G2HUMGEOG: "#E4A607",
  G2HUMHIST: "#E4A607",
  G2HUMSS: "#E4A607",
  "G2LIT(EL)": "#E4A607",
  G2MATHS: "#F3812F",
  "ML N(A)": "",
  G2ML: "#24BDC7",
  G2NFS: "#AF75D2",
  G2PL: "#24BDC7",
  G2SCI: "#73C235",
  "G2SCI(P,C)": "#73C235",
  G2SCIBIO: "#73C235",
  G2SCICHEM: "#73C235",
  G2SCIPHY: "#73C235",
  "HUM (SS,LE)": "",
  "G2SS&LIT-E": "#E4A607",
  G2TL: "#24BDC7",
  G2UL: "#24BDC7",
  G3UL: "#24BDC7",
  G3ACC: "#24BDC7",
  G3AMATHS: "#F3812F",
  "A MATHS": "",
  AL: "#707880",
  "G3ARAB-L2": "",
  "G3ARAB-L3": "#707880",
  G3ART: "#F17E7E",
  "ART('O')": "",
  G3BHSINDO: "#707880",
  G3BIO: "#73C235",
  BIOLOGY: "",
  G3BIOTECH: "#AF75D2",
  G3BIZSTU: "#AF75D2",
  G3BL: "#24BDC7",
  G3BURMESE: "#707880",
  G3CHEM: "#73C235",
  CHEMISTRY: "",
  G3CL: "#24BDC7",
  "G3CL(SP)": "#24BDC7",
  "G3CL(SP)NE": "",
  G3COMP: "#AF75D2",
  G3DESIGNST: "#AF75D2",
  G3DRAMA: "#2B63D9",
  G3ECONS: "#AF75D2",
  G3EL: "#2B63D9",
  "EL 1": "",
  G3ELECTRO: "#AF75D2",
  "G3EX&SPSCI": "#F17E7E",
  "EXER&SPSCI": "",
  "G3F&N": "#AF75D2",
  G3FRENCH: "#707880",
  G3GEOG: "#E4A607",
  G3GERMAN: "#707880",
  G3GL: "#24BDC7",
  G3HCL: "#24BDC7",
  "HIGHER ART": "",
  G3HIGHART: "#F17E7E",
  G3HIGHMUS: "#F17E7E",
  HIST: "",
  G3HIST: "#E4A607",
  G3HL: "#24BDC7",
  G3HML: "#24BDC7",
  G3HTL: "#24BDC7",
  G3HUMGEOG: "#E4A607",
  G3HUMHIST: "#E4A607",
  G3HUMSS: "#E4A607",
  G3JAPANESE: "#707880",
  "G3LIT(CL)": "#24BDC7",
  "G3LIT(EL)": "#E4A607",
  "G3LIT(ML)": "#24BDC7",
  "G3LIT(TL)": "#24BDC7",
  G3MATHS: "",
  G3ML: "#24BDC7",
  "G3ML(SP)": "#24BDC7",
  "G3ML(SP)NE": "#24BDC7",
  G3MUSIC: "#F17E7E",
  G3NFS: "#AF75D2",
  PHYSICS: "",
  G3PHY: "#73C235",
  G3PL: "#24BDC7",
  G3POA: "#AF75D2",
  G3PW: "#2B63D9",
  "SCI (S/E)": "",
  G3SCI: "#73C235",
  "G3SCI(C,B)": "#73C235",
  "G3SCI(P,B)": "#73C235",
  "G3SCI(P,C)": "#73C235",
  G3SCIBIO: "#73C235",
  G3SCICHEM: "#73C235",
  G3SCIPHY: "#73C235",
  G3SPANISH: "#707880",
  "G3SS&GEOG": "#E4A607",
  "HUM (SS,HE)": "",
  "G3SS&HIST": "#E4A607",
  "HUM (SS,LC)": "",
  "G3SS&LIT-C": "#E4A607",
  "G3SS&LIT-E": "#E4A607",
  "G3SS&LIT-M": "#E4A607",
  "G3SS&LIT-T": "#E4A607",
  G3THAI: "#707880",
  G3TL: "#24BDC7",
  GEOG: "#E4A607",
  GERMAN: "#707880",
  GL: "#24BDC7",
  GUJARATI: "#24BDC7",
  "H1 BENGALI": "#24BDC7",
  "H1 PANJABI": "#24BDC7",
  "H1 URDU": "#24BDC7",
  H1ART: "#F17E7E",
  H1BIO: "#73C235",
  H1BL: "#24BDC7",
  H1CHEM: "#73C235",
  "H1CHINA-EL": "#E4A607",
  H1CL: "#24BDC7",
  H1ECONS: "#AF75D2",
  H1FRENCH: "#707880",
  H1GENSTUCL: "#24BDC7",
  H1GEOG: "#E4A607",
  H1GERMAN: "#707880",
  H1GL: "#24BDC7",
  H1GP: "#2B63D9",
  H1GUJARATI: "#24BDC7",
  H1HISC: "#E4A607",
  H1HIST: "#E4A607",
  H1HL: "#24BDC7",
  H1IS: "#24BDC7",
  H1JAPANESE: "#707880",
  "H1LIT(EL)": "#2B63D9",
  H1MATHS: "#F3812F",
  H1ML: "#24BDC7",
  H1PHY: "#73C235",
  H1PL: "#24BDC7",
  H1PW: "#2B63D9",
  H1STATS: "#F3812F",
  H1TL: "#24BDC7",
  H1UL: "#24BDC7",
  "H2 ART": "#F17E7E",
  "H2 CSE": "#E4A607",
  H2BIO: "#73C235",
  H2CHEM: "#73C235",
  "H2CHINA-CL": "#24BDC7",
  "H2CHINA-EL": "#E4A607",
  "H2CL&L": "#24BDC7",
  H2CLTRANS: "#24BDC7",
  H2COMP: "#AF75D2",
  H2ECONS: "#AF75D2",
  "H2EL&L": "#2B63D9",
  H2FMATHS: "#F3812F",
  H2FRENCH: "#707880",
  H2GEOG: "#E4A607",
  H2GERMAN: "#707880",
  H2HISC: "#E4A607",
  H2HIST: "#E4A607",
  H2IS: "#E4A607",
  H2JAPANESE: "#707880",
  H2KI: "#2B63D9",
  "H2LIT(EL)": "#2B63D9",
  H2MATHS: "#F3812F",
  "H2ML&L": "#24BDC7",
  H2MOBIZ: "#AF75D2",
  H2MUS: "#F17E7E",
  H2PHY: "#73C235",
  H2POA: "#AF75D2",
  H2SPANISH: "#707880",
  "H2TL&L": "#24BDC7",
  "H2TS&DRAMA": "#2B63D9",
  H3ART: "#F17E7E",
  H3BIO: "#AF75D2",
  H3CHEM: "#73C235",
  "H3CL&L": "#24BDC7",
  H3ECONS: "#AF75D2",
  H3GAMETHEO: "#AF75D2",
  H3GEOG: "#E4A607",
  H3HIST: "#E4A607",
  H3HSSRCLL: "#24BDC7",
  H3HSSRECON: "#E4A607",
  H3HSSRGEOG: "#E4A607",
  H3HSSRHIST: "#E4A607",
  H3HSSRLIT: "#E4A607",
  H3HSSRMLL: "#24BDC7",
  H3HSSRPCLL: "#24BDC7",
  H3HSSRPLIT: "#E4A607",
  "H3LIT(EL)": "#2B63D9",
  H3MATHS: "#F3812F",
  "H3ML&L": "#24BDC7",
  H3MUS: "#F17E7E",
  H3NTUCOP: "#73C235",
  H3NTUHSRBI: "#73C235",
  H3NTUHSRCH: "#73C235",
  H3NTUHSRMA: "#F3812F",
  H3NTUHSRPH: "#73C235",
  H3NTUMOLBI: "#73C235",
  H3NTUNAM: "#F3812F",
  H3NTUORSYM: "#AF75D2",
  H3NTUSPHYD: "#73C235",
  H3NTUSRBI: "#73C235",
  H3NTUSRCH: "#73C235",
  H3NTUSRMA: "#F3812F",
  H3NTUSRPH: "#73C235",
  H3NUSBIODI: "#73C235",
  H3NUSESRBI: "#73C235",
  H3NUSESRCH: "#73C235",
  H3NUSESRMA: "#F3812F",
  H3NUSESRPH: "#73C235",
  H3NUSFMATH: "#F3812F",
  H3NUSGPOLS: "#E4A607",
  H3NUSLALG1: "#F3812F",
  H3NUSMOPHY: "#73C235",
  H3NUSNSRBI: "#73C235",
  H3NUSNSRCH: "#73C235",
  H3NUSNSRMA: "#F3812F",
  H3NUSNSRPH: "#73C235",
  H3NUSPCHEM: "#73C235",
  H3NUSRSRBI: "#73C235",
  H3NUSRSRCH: "#73C235",
  H3NUSRSRMA: "#F3812F",
  H3NUSRSRPH: "#73C235",
  H3NUSSPACE: "#AF75D2",
  H3NUSVSRBI: "#73C235",
  H3NUSVSRCH: "#73C235",
  H3NUSVSRMA: "#F3812F",
  H3NUSVSRPH: "#73C235",
  H3PHY: "#73C235",
  "H3TL&L": "#24BDC7",
  HCL: "#24BDC7",
  "HEALTH ED": "#AF75D2",
  "HIGHER MUS": "#F17E7E",
  HINDI: "#24BDC7",
  "HIST(WA)": "#E4A607",
  "HL (Chosen)": "#24BDC7",
  HML: "#24BDC7",
  HOMEC: "#AF75D2",
  HTL: "#24BDC7",
  IRK: "#707880",
  ISO: "#AF75D2",
  JAPANESE: "#707880",
  "LIFE SC": "#73C235",
  "LIT(C)": "#24BDC7",
  "LIT(E)": "#E4A607",
  "MAKER-ED": "#AF75D2",
  MATHS: "#F3812F",
  "MATHS (NA)": "#F3812F",
  ML: "#24BDC7",
  MLB: "#24BDC7",
  MUSIC: "#F17E7E",
  "MUSIC('O')": "#F17E7E",
  "MUSIC(HMP)": "#F17E7E",
  "MUSIC(MEP)": "#F17E7E",
  OECIECOMP: "#AF75D2",
  OECIEDRAMA: "#2B63D9",
  OECIEPE: "#F17E7E",
  PANJABI: "#24BDC7",
  PE: "#F17E7E",
  "PHY SC": "#73C235",
  "PHY(SPA)": "#73C235",
  PL: "#24BDC7",
  PPL: "#AF75D2",
  PW: "#2B63D9",
  "S STUD-GEP": "#E4A607",
  SCI: "#73C235",
  "SCI(NA)": "#73C235",
  "SCI(NT)": "#73C235",
  SIL: "#707880",
  "SLS CHAR CITIZENSHIP": "#B44931",
  "SLS CHINESE ELECTIVE": "#24BDC7",
  "SLS ENGLISH ELECTIVE": "#24BDC7",
  "SLS FORM TEACHER": "#B44931",
  "SLS GEO ELECTIVE": "#E4A607",
  "SLS HIST ELECTIVE": "#E4A607",
  "SLS MALAY ELECTIVE": "#24BDC7",
  "SLS SCI BIO": "#73C235",
  "SLS SCI CHEM": "#73C235",
  "SLS SCI PHY": "#73C235",
  "SLS SS ELECTIVE": "#E4A607",
  "SLS TAMIL ELECTIVE": "#24BDC7",
  SLSPD: "#707880",
  "SOC STUD": "#E4A607",
  "SOCIAL ST": "#E4A607",
  SPANISH: "#707880",
  "SS N(T)": "#E4A607",
  SS: "#E4A607",
  "SS(CL)": "#E4A607",
  THAI: "#707880",
  TL: "#24BDC7",
  "TL N(A)": "#24BDC7",
  TLB: "#24BDC7",
  TRANSITSMS: "#707880",
  UL: "#24BDC7",
  URDU: "#24BDC7",
  "V ART": "#F17E7E",
};

function getSubjectColorInHex(subjectKey: string): string {
  return !isEmpty(subjectKey) ? SUBJECT_COLOR_MAP[subjectKey] : "";
}

export default {
  getSubjectColor: (subjectKey: string): string => {
    // Default hex code is #707880 if there is no color tagging for the subject
    // https://www.figma.com/file/T0fwO7S23LQXoOpNu1dv9A/Subject-Colors?node-id=163%3A10554
    const hexColor: string = getSubjectColorInHex(subjectKey);
    return !isEmpty(hexColor) ? hexColor : "#707880";
  },
};
